import { AssessmentType } from '@@types/api.types';
import { useAssessmentsQueryOptions } from '@queries/assessment.query';
import { useQuery } from '@tanstack/react-query';
import { TechnologyHeaderTab } from '@utils/query-state.util';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { TrlSummaryStats } from './trl/overview/trl-summary-stats.component';

type TrlSummaryWrapperProps = {
  onNavigateToTab?: (tab: TechnologyHeaderTab) => void;
};

export const TrlSummaryWrapper: FC<TrlSummaryWrapperProps> = (props) => {
  const { onNavigateToTab } = props;
  const { technologyId } = useParams();

  const assessmentQueryOptions = useAssessmentsQueryOptions({
    technologyId,
    type: [AssessmentType.TRL],
  });
  const { data: assessments = [], isPending: isAssessmentsLoading } = useQuery(assessmentQueryOptions);

  const handleNavigateToAssessment = () => {
    onNavigateToTab?.('trl');
  };

  return (
    <TrlSummaryStats
      assessments={assessments}
      isLoading={isAssessmentsLoading}
      onNavigateToAssessment={handleNavigateToAssessment}
    />
  );
};
